import Vue from 'vue';
import SweetUI from '@sweet/ui';

Vue.use(SweetUI);

export default SweetUI;
